/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Isprotocolnote2Inputs */

const de__field_isprotocolnote2 = /** @type {(inputs: _Field_Isprotocolnote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Protokollnotiz`)
};

/**

* @param {_Field_Isprotocolnote2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_isprotocolnote2 = /** @type {((inputs?: _Field_Isprotocolnote2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Isprotocolnote2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_isprotocolnote2(inputs)
});
export { _field_isprotocolnote2 as "_field_isProtocolNote" }